export default __webpack_public_path__ + "static/media/minicard9.695d6647.jpg";